import { render, staticRenderFns } from "./audiotopic.vue?vue&type=template&id=341f6419&scoped=true"
import script from "./audiotopic.vue?vue&type=script&lang=js"
export * from "./audiotopic.vue?vue&type=script&lang=js"
import style0 from "./audiotopic.vue?vue&type=style&index=0&id=341f6419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341f6419",
  null
  
)

export default component.exports